import { Aperture, Ban, Image as ImageIcon } from "lucide-react";
import type { BackgroundEffect } from "../types";

export interface EffectIconProps {
  effect: BackgroundEffect;
  className?: string;
}

/**
 * EffectIcon - Renders the icon representing a background effect.
 */
export const EffectIcon = ({ effect, className }: EffectIconProps) => {
  if (effect === "blur") return <Aperture className={className} />;
  if (effect === "image") return <ImageIcon className={className} />;
  return <Ban className={className} />;
};
